import React from 'react';
import ReactDOM from 'react-dom';
import ExternalLinkIcon from './images/external-link-icon.png';
import TrackingActions from 'medscape/tracking';
import Utils from 'medscape/utils';

export default class AdditionalResourcesComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
      let titleProps = {
          dangerouslySetInnerHTML: Utils.getDangerousHtml(this.props.title)
      }
    let resources = this.getResources();
    return (
      <div className="additional-resources-component">
        <h4 {...titleProps}></h4>
        <ul className="resources-container">
          { resources }
        </ul>
      </div>
    );
  } // render

  getResources() {
    let _resources = this.props.resources;
    let resources = _resources.map( (data,index) => {
      let itemKey = "resource-"+index;
      return(
          <ResourceItem key={itemKey} moduleId={this.props["config-id"]} {...data} />
      );
    });
    return resources;
  } // getReources
}
AdditionalResourcesComponent.propTypes={
  "title": React.PropTypes.string,
  "resources": React.PropTypes.array
}
AdditionalResourcesComponent.defaultProps={
  "title": "Resources",
  "resources": []
}

class ResourceItem extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
  }
  render() {
    let image = this.props.image;
    let title = this.props.title;
    let description = this.props.description;
    let linkProps = this.props.link;
    return (
      <li className="resource-item">
        <span className="description" dangerouslySetInnerHTML={Utils.getDangerousHtml(description)} />
        <Link {...linkProps} linkId={this.props["config-id"]} moduleId={this.props.moduleId}/>
      </li>
    );
  } // render
}

ResourceItem.propTypes={
  "description": React.PropTypes.string,
  "link": React.PropTypes.object
}
ResourceItem.defaultProps={
  "description": "",
  "link": {}
}

class Link extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        let $this = $(ReactDOM.findDOMNode(this));
        TrackingActions.trackLink($this[0]);
    }
    handleClick(e){
      let url = (this.props.url.startsWith('http') || this.props.url.startsWith('www')) ? this.props.url : `${window.medscape.config.staticServer.host}${this.props.url}`;
      if(url.indexOf(".medscape.")<0){
        return;
      }
      let module = `addres-${this.props.moduleId}-${this.props.linkId}`;
      TrackingActions.pageLink(module);
    }
    render() {
      let title = this.props.title;
        let type = this.props.type;
        let url = (this.props.url.startsWith('http') || this.props.url.startsWith('www')) ? this.props.url : `${window.medscape.config.staticServer.host}${this.props.url}`;
        let linkProps = {
            href: url,
            className: (type==='iconCopy' ? 'external-link' : 'button'),
            target: this.props.target
        }
        let titleHtml = Utils.getDangerousHtml(title);
        if(type==='iconCopy'){
            return (
                <a {...linkProps} onClick={this.handleClick.bind(this)}><span className="title" dangerouslySetInnerHTML={titleHtml}></span> <span className="icon"><img src={ExternalLinkIcon} /></span></a>
            )
        }
      return (
        <a {...linkProps} onClick={this.handleClick.bind(this)}><span className="title"  dangerouslySetInnerHTML={titleHtml}></span></a>
      );
    } // render
}

Link.propTypes={
  "url": React.PropTypes.string,
  "title": React.PropTypes.string,
    "type": React.PropTypes.string,
    "target": React.PropTypes.string
}
Link.defaultProps={
  "url": "",
  "title": "",
    "type": "link",
    "target": ""
}



// WEBPACK FOOTER //
// ./src/app/additional-resources/app.jsx